import { render } from "./video-attachment.vue?vue&type=template&id=eccc00b8"
import script from "./video-attachment.vue?vue&type=script&lang=js"
export * from "./video-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__